import { ChangeDetectionStrategy, Component, HostListener, inject, OnInit } from '@angular/core';

import { SharedLanguageService } from '@language';
import { ApiFragment, BaseContainer, DialogConfig, DialogRef } from '@stylehaven/components';
import { ClipboardService } from 'ngx-clipboard';
import { PortalShareDialogConfig } from '../entities/share-dialog-config.entity';

@Component({
    selector: 'med-share-dialog',
    templateUrl: './portal-share-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PortalShareDialogComponent extends BaseContainer implements OnInit {
    public readonly data: PortalShareDialogConfig;
    public record: ApiFragment;
    public url: string;

    public dialogContainer: HTMLElement | null;

    private readonly clipboard: ClipboardService = inject(ClipboardService);

    constructor(
        public config: DialogConfig<PortalShareDialogConfig>,
        public dialog: DialogRef<boolean>,
        public lang: SharedLanguageService
    ) {
        super();

        if (!config.data) {
            throw new Error('ShareDialog needs a configuration object');
        }
        this.data = config.data;
        this.record = config.data.record;

        console.assert(!!this.data.url, 'Unexpected: Url is empty in Share dialog');
        this.url = this.data.url || '';
    }

    @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent) {
        this.clipboard.copyFromContent(this.url, document.querySelector('dialog') as HTMLElement);
        this.copySuccess();
    }

    ngOnInit(): void {
        this.dialogContainer = document.querySelector('dialog') as HTMLElement | null;
    }

    copySuccess(event?: ClipboardEvent): void {
        this.dialog.close(true);
    }

    copyFailure(event: ClipboardEvent): void {
        console.error(`Copying to clipboard failed: ${event}`);
        this.dialog.close(false);
    }

    cancel(): void {
        this.dialog.close();
    }
}
